// src/redux/thunks/saveAppointmentsToDb.js//to retrive appoinmnets also
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';
export const saveAppointmentsToDb = createAsyncThunk(
  'appointments/saveToDb',
  async (appointmentData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/appointments/save`,
        appointmentData,
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to save appointment'
      );
    }
  }
);
